import { render, staticRenderFns } from "./serverContentDialog.vue?vue&type=template&id=13985ef9&scoped=true&"
import script from "./serverContentDialog.vue?vue&type=script&lang=js&"
export * from "./serverContentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13985ef9",
  null
  
)

export default component.exports